import React, {Component} from 'react';
import {Badge, Button, ButtonGroup, Nav, NavItem, NavLink} from 'reactstrap';
import {Polyline} from "react-google-maps";
import HTML from '../../common/HtmlHelpers';
import SplitPane from 'react-split-pane';
import "./Maps.css";
import TTLProxy from "../../common/TTLAsyncProxy";
import {MiscEndpoints, TrackerEndpoints} from "../../common/ProxyEndpoints";
import DatePicker from 'react-datepicker';
import Utils, {containsText} from "../../common/Utils";
import SmartDialog from "../../components/SmartDialog/SmartDialog";
import MapBase from "./MapBase";
import ReactTable from 'react-table';
import DocumentTitle from 'react-document-title';
import ProgressMD from 'react-md-progress-bar';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import ReactTimer from "../../common/ReactTimer";
import _ from 'lodash';
import CsvExport from '../../common/CSVExport';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
// with es6
import SessionStateManager from "../../common/SessionStateManager";
import PlayerControls from "../../components/PlayerControls/PlayerControls";
import {GPSDeviceStatus} from "../../common/Constants";
import PropTypes from 'prop-types';
import DataList from "../../components/TableListView/DataList";
import {css} from 'glamor';
import {findNearest} from "geolib";
import {ActionSelectDialog} from "../../components/ActionSelectDialog/ActionSelectDialog";
import classnames from 'classnames';
import AreaCalculator from "../../components/AreaCalculatorDialog/AreaCalculator";
import LocationListener from "../../common/LocationListener";
import QueryString from "query-string";
import history from "../../history";
import {createQuery, joinQuery} from "../../components/FilterQueryWrapper/FilterQueryWrapper";
import {Async as AsyncSelect, components} from "react-select";
import ThreeLineItemRender from "../../components/Elements/ThreeLineItemRender";

const MaxTractorsPerView = 5;

const DEFAULT_ZOOM = 7;
const ZOOM_SELECTED = 17;

const mapStyle = {
    width: '100%',
    height: '100%',
    position: 'inherit !important'
};

const locationItemRow = css({
    cursor: "pointer"
});

const selectedLocationRow = css({
    backgroundColor: "rgba(0,120,206,0.53)"
});

const tractorItemStyle = css({
    color: "#0078ce",
    cursor: "pointer"
});

const Styles = {

    full: {
        height: "100%" ,
        width:"100%"
    }

};

const NavTabs = [
    {
        name: "tractors",
        title: "Tractors",
        icon: 'tractor'
    },
    {
        name: "location",
        title: "Location History",
        icon: 'fa fa-map-marker'
    },
    /*{
        name: "geofence",
        title: "Geofence",
    }*/
];

const ReportTypes  = {
    Summary: "summary",
    Mileage: "mileage",
    Fuel: "fuel"
};

class DeviceCommandsDialog extends React.Component {

    constructor(props){
        super(props);
        this.state = this.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    getInitialState(tracker= null){

        return {
            isBusy: false,
            commands: null,
            tracker: tracker
        };

    }

    loadState(){

        const proxy = this.proxy;
        const tracker = this.state.tracker;
        if(!tracker){
            return;
        }

        this.setState({
            isBusy: true
        });

        //  get device commands
        return proxy.processRequest( TrackerEndpoints.getTrackerCommands(tracker.id) ).then(response => {

            const payload = response.getPayload();
            this.setState({
                commands: payload,
                isBusy: false
            });

        }).catch(err => {

            this.setState({
                isBusy: false
            });

            HTML.toastWarning( Utils.getResponseError(err) );

        });

    }

    show(tracker){

        //  set the state
        this.setState(this.getInitialState(tracker),() => {
            return this.loadState();
        });

        //  show dialog
        this._dlg.show();
    }

    render(){

        return <SmartDialog title={"Device Commands"} ref={r => this._dlg = r}>

            <div className="row">

                <div className="col-md-2">

                </div>

                <div className="col-md-10">

                </div>

            </div>

        </SmartDialog>;
    }

}

const HistoryPolyLine = ({ history , ...props }) => {

    return <Polyline
        path={history}
        options={{strokeColor: '#0078ce', geodesic: true, strokeOpacity: 0.85 }}
        {...props}/>
};

const CollapseToggleButton = ({ onToggle , isToggled  , activeClass , inactiveClass , style , className}) => {

    return <button type="button" className={classnames('text-center',isToggled ? activeClass : inactiveClass,className)} onClick={onToggle} style={style}>
        {isToggled ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i> }
    </button>
};

const filterTractors = (tractors,keyword) => {

    const containsText = (text,kwd) => {
        return text.toLowerCase().indexOf(kwd.toLowerCase()) >= 0;
    };

    //  trim keyword
    keyword = keyword.trim();

    return tractors.filter(t => {
        return containsText(t.name,keyword) || containsText(t.registration_number,keyword) ||
            containsText(t.chassis,keyword) || containsText(t.year.toString(),keyword) ||
            containsText(t.tractor_model,keyword) ||
            (t.tracker ? containsText(t.tracker.imei,keyword) : false) ||
            (t.owner ? containsText(t.owner.name,keyword) : false) ||
            (t.operator ? containsText(t.operator.name,keyword) : false )
    });

};

class MapFull extends Component {

    static propTypes = {
        showOwner: PropTypes.bool,
        sessionKey: PropTypes.string,

        getTractorsUrl: PropTypes.func,
        getLocationsEndpoint: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.session = new SessionStateManager(props.sessionKey,true);
        this.state = {

            //
            currentPage: 0,

            //  Player
            isPlaying: false,
            isPaused: false,
            isCompleted: false,

            //  Bottom state collapsed
            isBottomCollapsed: false,

            //
            searchKeyword: "",
            showTrackedOnly: true,

            //  General State
            searchTractors: null,
            zoom: DEFAULT_ZOOM,

            tractors: null,
            trackers: null,
            selectedItem: null,

            //  History fetch data
            historyTractor: null,
            historyData: null,

            //  Location map
            locationMap: {},

            //  Reports
            reportData: null,
            reportType: ReportTypes.Summary,

            //  From Query
            ...this.parseQueryParams(QueryString.parse(history.location.search)),

            //  Working State
            isBusy: false,
            isLoaded: false,
            faulted: false,


            actualHeight: window.innerHeight || document.body.clientHeight,
            actualWidth: window.innerWidth || document.body.clientWidth,
        };

        //  get proxy instance
        this.proxy = TTLProxy.getInstance();

        //  Set Unmounted
        this._isMounted = false;

        //  Follow selected view
        this._followSelected = true;

        this._followSelectTimer= new ReactTimer(() => {

            //  pan view to selected
            const selected = this.state.selectedItem;
            if(selected && this._followSelected && this.state.tab !== 'location'){
                this._map.panTo(selected.lat,selected.lng);
            }

        }, 4000);
    }

    getCurrentTractorsViewPage(){
        return this.state.currentPage;
    }

    setStateSafe(state,callback){

        if(this._isMounted)
            this.setState(state,callback);
    }


    handleTractorSelected(marker,tractor){

        if(this._addressResolutionTimer)
            this._addressResolutionTimer.stop();

        //
        const timer = new ReactTimer(async () => {

            if(!this._isMounted || this._isResolvingAddress)
                return false;

            //  set resolving address
            this._isResolvingAddress = true;

            try {

                const _selectedMarker = this._map.getSelectedMarker();
                if(this._isMounted && (_selectedMarker && (_selectedMarker.tractor.id === marker.tractor.id) )){

                    const response = await  this.proxy.processRequest(MiscEndpoints.resolveCoordinates([
                        {
                            lat: marker.location.lat,
                            lng: marker.location.lng,
                            key: tractor.id
                        }
                    ]));

                    //  Gets the payload
                    const payload = response.getPayload();

                    // set marker address
                    this._map.setMarkerAddress(marker,payload[0].address);

                }
                else{
                    return false; // stop timer
                }

            }
            catch (e) {
                console.log('Failed resolving address for selected tractor');
            }
            finally {
                this._isResolvingAddress = false;
            }

            return this._isMounted;
        }, 12000);

        //
        this._addressResolutionTimer = timer;

        //  start timer immediately if address not resolved yet
        if(!marker.address){
            window.setTimeout(() => timer.start(true),2500);
        }
        else{
            timer.start();
        }
    }

    onUpdatePositions(){

        if(!this._isMounted)
            return;

        //  use proxy to query tractor geo data
        this.setState({
            markers: this.state.markers
        });

    }

    onMapLoad(){

        //  TODO: Handle Map Loaded

    }

    /**
     * Invoked when a new tab is activated
     * @param tab
     */
    onActivateTab(tab){

        switch (tab){
            case "tractors":{

                //  stop animation and
                this._map.stopAnimation();

                //
                this._map.leavePlaybackMode();

                //  clear history
                this.setStateSafe({
                    locationRangeStart: null,
                    locationRangeEnd: null,
                    historyData: null,
                    historyTractor: null,
                    isPlaying: false,
                    isComplete: false,
                    isPaused: false
                });

            }break;
            case "location":{

                //  actions here...


            }break;
        }
    }

    saveSession(){

        this.session.putStateFrame({
            tab: this.state.tab,
            orientation: this.state.orientation
        }).save();
    }

    loadTractors(){

        const options = {
            method: "get",
            include: [ "media" ,"operator" , "owner" , "tracker" ],
            query: {
                tracked: true
            }
        };

        //  get all tractors
        return this.proxy.processRequest( this.props.getTractorsUrl() ,options).then(response => {

            let tractors = this.filterTractors( response.getPayload() );
            this.setState({
                tractors
            });

        });
    }

    componentDidMount() {

        this._isMounted = true;

        this.setState({
            isBusy: true
        });


        //
        return Promise.all([

            //  get all trackers
            this.loadTractors()

        ]).then(() => {

            //
            this.setState({
                isLoaded: false,
                faulted: true,
                isBusy: false
            });

        }).catch(err => {

            HTML.toastWarning(Utils.getResponseError(err));

            this.setState({
                isBusy: false,
                faulted: true
            });

        });

    }

    _canLoadTractorHistory(){
        return this.state.historyTractor && this.state.locationRangeEnd && this.state.locationRangeStart;
    }

    loadTractorHistory(fitView = true){

        //
        if(!this._canLoadTractorHistory()){
            return Promise.resolve();
        }

        //
        const start = this.state.locationRangeStart;
        const end = this.state.locationRangeEnd;
        const trackerId  = this.state.historyTractor.tracker.id;

        //
        this.setState({
            isBusy: true
        });

        return this.proxy.processRequest( TrackerEndpoints.getTrackerLocationHistory(trackerId, {
            start: moment(start).toDate().toJSON(),
            end: moment(end).toDate().toJSON()
        })).then(response => {

            //
            const _payload = response.getPayload().filter(x => x.data_type == 1);

            this.setState({
                isBusy: false,
                historyData: _payload,
                _selectedLocationPt: null
            }, () => {
                this._historyDataList.refresh();
            } );

            //  fit view
            if(fitView){
                this.fitCoords(_payload);
            }

            if(_payload.length > 0) {

                //  set playback data
                this._map.setPlaybackData(_payload, () => {
                    this._map.movePlaybackToTrack(0);
                });

            }

            return _payload;

        }).catch(err => {

            this.setState({
                isBusy: false
            });

            HTML.toastWarning(Utils.getResponseError(err));
        });

    }

    filterTractors(tractors){
        return this.state.showTrackedOnly ? tractors.filter(x => x.tracker !== null) : tractors;
    }

    getTractors(options){

        return this.proxy.processRequest( this.props.getTractorsUrl()  ,options).then(response => {

            let tractors =  this.filterTractors(response.getPayload());

            this.setState({
                tractors: tractors
            });


            return tractors;
        });

    }

    fitView(){

        const trackers = this.state.trackers;
        if(trackers.length === 1){
            this._map.panTo( trackers[0].lat , trackers[0].lng );
        }
        else if(trackers.length > 1) {
            const bounds = new window.google.maps.LatLngBounds();
            trackers.forEach(t => bounds.extend(new window.google.maps.LatLng(t.lat,t.lng) ));
            this._map.fitBounds(bounds);
        }

    }

    fitCoords(coords){

        if(coords.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            coords.forEach(t => bounds.extend(new window.google.maps.LatLng(t.lat, t.lng)));
            this._map.fitBounds(bounds);
        }

    }

    getLocations(tractors){

        return this.proxy.processRequest( this.props.getLocationsEndpoint() ).then(response => {

            const trackers = response.getPayload();

            this.setState({
                trackers: trackers
            }, () => {

                //  pan the view to make all tractors visible
                if(!this._initPan){

                    this._initPan = true;

                    //  Parse query
                    const query = QueryString.parse(history.location.search);
                    if(query.active_tractor){

                        switch (this.state.tab) {

                            case "location":{

                                const id = query.active_tractor;
                                const tractor = tractors.find(x => x.id == id);

                                if(tractor){

                                    this.setState({
                                        historyTractor: tractor
                                    });

                                }

                            }break;

                        }

                    }

                    //  fit view
                    this.fitView();
                }

            });


            return trackers;
        });

    }

    componentWillUnmount(){
        this.saveSession();
        this._isMounted = false;
    }


    focusTractor(tractor){

        //  Center tractor on map view
        const trackers = this.state.trackers || [];
        const item =  trackers.find(x => x.imei === tractor.tracker.imei);
        if(item){
            this._map.panTo(item.lat,item.lng);
        }

        if(this._map.isInfoWindowActive()) {
            this._map.showInfoWindow(tractor);
        }

        this.setStateSafe({ zoom: ZOOM_SELECTED });
    }

    getListTractors(){
        return this.state.searchTractors || this.state.tractors || [];
    }

    getTractorInList(index){
        return this.getListTractors()[index];
    }

    renderPage(page){

        const state = this.state;

        let content;
        switch (page){
            case "tractors":

                let Columns = [
                    {
                        Header: "Name",
                        className: "text-center",
                        Cell: (row) => {

                            const tractor = this.getTractorInList(row.index);
                            return <span className={`${tractorItemStyle}`} title="Click to select tractor" onClick={() => {
                                this.focusTractor(tractor);
                            }}>{tractor.name} ({tractor.registration_number})</span>;
                        }
                    }];

                if(this.props.showOwner){

                    Columns = Columns.concat({
                        Header: "Owner",
                        className: "text-center",
                        Cell: (row) => {
                            const tractor = this.getTractorInList(row.index);
                            return <span>{tractor.owner ?  tractor.owner.name : <h6><Badge pill={true}>Unassigned</Badge></h6>}</span> ;
                        }
                    });

                }

                Columns = Columns.concat([
                    {
                        Header: "Operator",
                        className: "text-center",
                        Cell: (row) => {
                            const tractor = this.getTractorInList(row.index);
                            return  <span>{tractor.operator ? tractor.operator.name : <h6><Badge pill={true}>Unassigned</Badge></h6>}</span>;
                        }
                    },
                    {
                        Header: "",
                        className: "text-center",
                        Cell: (row) => {
                            const tractor = this.getTractorInList(row.index);
                            return tractor.tracker ? <div>

                                <Button size={"sm"} className="m-0" style={{ borderRadius: 4 , marginRight: 2 }} onClick={() => {

                                    //  Switch to location tab
                                    this.setActiveTab("location");

                                    //  Set history tractor to
                                    this.setState({
                                        historyTractor: tractor,
                                    },() => {

                                        //  apply filters
                                        this.applyFilters();

                                        //  enter history mode
                                        this._map.enterPlaybackMode(tractor, [tractor] );

                                    });


                                }}><i className="fa fa-history"/> History</Button>

                                {/*<Button size={"sm"} style={{ borderRadius: 4 }} onClick={() => {

                                }}>Commands</Button>*/}

                            </div> : null;

                        }
                    }
                ]);

                content = <div>
                    <ReactTable data={this.getListTractors()}
                                columns={Columns}
                                pageSizeOptions={[MaxTractorsPerView,MaxTractorsPerView*2]}
                                defaultPageSize={MaxTractorsPerView}
                                noDataText={"No tractors available"}
                                showPagination={true}
                                onPageChange={p => {

                                    this.setState({
                                        currentPage: p
                                    });
                                }}
                                showPaginationBottom={true}
                                ref={r => this._tractorsView = r}/>
                </div>;
                break;
            case "location":

                const tractors = (this.state.tractors || []).filter(x => x.tracker !== null);
                const me = this;
                const getTractorLabel = (t) => ({ label: `${t.name} (${t.registration_number})` , value: t.id  , instance: t });

                if(!this.state.isBusy) {

                    if (tractors.length > 0) {
                        content = <div style={{padding: 10}}>

                            <ActionSelectDialog ref={r => this._historyActionDlg = r} title={"Select an action"}/>

                            <AreaCalculator getTractorsUrl={this.props.getTractorsUrl}
                                            ref={r => this._areaCalculator = r} />

                            <div className="row">

                                <div className="col-md-6">
                                    <h6><i className="fa fa-history"/> Active Tractor</h6>
                                    <AsyncSelect  name="tractor"
                                                  defaultOptions
                                                  cacheOptions
                                                  placeholder="Select tractor..."
                                                  value={state.historyTractor ? getTractorLabel(state.historyTractor)  : null}
                                                  onChange={selected => {

                                                      const historyTractor = tractors.find(x => x.id === selected.value);

                                                      if(historyTractor && this.state.historyTractor === historyTractor){
                                                          return;
                                                      }

                                                      let _payload = {
                                                          historyTractor
                                                      };

                                                      if(historyTractor){
                                                          _payload.locationRangeStart = null;
                                                          _payload.locationRangeEnd = null;
                                                      }

                                                      this.setStateSafe(_payload, () => {

                                                          if(historyTractor){

                                                              //  enter history mode
                                                              this._map.enterPlaybackMode(historyTractor, [historyTractor] );

                                                              //  focus
                                                              this.focusTractor(historyTractor);

                                                          }
                                                          else{

                                                              //  just fit the current view
                                                              this.fitView();

                                                              //  render all tractors
                                                              this._map.leavePlaybackMode();
                                                          }


                                                          //
                                                          this.applyFilters();
                                                      });

                                                  }}
                                                  components={{
                                                      Option: ({ children , ...props }) => {

                                                          const tractor = props.data.instance;
                                                          return <components.Option {...props}>

                                                              <ThreeLineItemRender media={tractor.media}
                                                                                 line1Value={`${tractor.name} (${tractor.registration_number})`}
                                                                                 line2Prefix="Chassis"
                                                                                 line2Value={tractor.chassis}
                                                                                 line3Prefix="Operator"
                                                                                 line3Value={tractor.operator ? tractor.operator.name : "Not Assigned"}/>

                                                          </components.Option>

                                                      }
                                                  }}
                                                  loadOptions={async (value) => {

                                                      //    local lookup
                                                      return Utils.paginate(tractors.filter(x => containsText(x.name,value) ||
                                                          containsText(x.chassis,value) ||
                                                          containsText(x.registration_number,value) ||
                                                          containsText(x.tractor_model,value) ||
                                                          (x.operator ? containsText(x.operator.name,value) : false)
                                                      ),0,5).map(x => getTractorLabel(x));

                                                  }}/>

                                </div>

                                <div className="col-md-2">
                                    <h6><i className="fa fa-calendar"/> Start</h6>
                                    <DatePicker
                                        className={"form-control form-input"}
                                        isClearable
                                        showTimeInput
                                        placeholderText="Select start date"
                                        onChange={(value) => {

                                            if(!_.isNil(value) && this.state.locationRangeEnd && moment(value).isAfter(moment(this.state.locationRangeEnd))){
                                                return window.alert('Start date cannot be greater than end date!');
                                            }

                                            me.setState({
                                                locationRangeStart: value
                                            }, () => {

                                                //  apply filters
                                                this.applyFilters();

                                            });


                                        }}
                                        selected={this.state.locationRangeStart}/>
                                </div>

                                <div className="col-md-2">
                                    <h6><i className="fa fa-calendar"/> End</h6>
                                    <DatePicker
                                        className={"form-control form-input"}
                                        isClearable
                                        placeholderText="Select end date"
                                        showTimeInput
                                        onChange={(value) => {

                                            if(!_.isNil(value) && this.state.locationRangeStart && moment(value).isBefore(moment(this.state.locationRangeStart))){
                                                return window.alert('End date should be greater than start date');
                                            }

                                            //
                                            me.setState({
                                                locationRangeEnd: value
                                            }, () => {

                                                //  apply filters
                                                this.applyFilters();
                                            });

                                            //
                                        }}
                                        selected={this.state.locationRangeEnd}/>

                                </div>

                                <div className="col-md-2">
                                    <Button color="primary"
                                            className="mt-4"
                                            disabled={!this._canLoadTractorHistory()}
                                            onClick={() => this.loadTractorHistory()}
                                            style={{ height: 40 }}
                                            block
                                            size="sm"><i className="fa fa-refresh"/> Load History</Button>
                                </div>


                            </div>

                            {state.historyData ? <div>

                                <hr/>

                                <div style={{textAlign: "center"}}>

                                    <PlayerControls
                                        ref={r => this._playerControls = r}
                                        canPlay={!!state.historyData}
                                        onPlay={() => {

                                            this.setState({
                                                _selectedLocationPt: null
                                            });

                                            if(this.state.isPaused){

                                                //  resume animation playback
                                                this._map.resumeAnimation();

                                                this.setState({
                                                    isPlaying: true,
                                                    isPaused: false,
                                                    isCompleted: false
                                                });

                                            }
                                            else{

                                                if(state.historyData && state.historyData.length> 0) {

                                                    this._map.playAnimation();
                                                    this.setState({
                                                        isPlaying: true,
                                                        isPaused: false,
                                                        isCompleted: false
                                                    });
                                                }
                                                else{
                                                    window.alert('No history found!');
                                                }
                                            }

                                        }}

                                        isPlaying={() =>{
                                            return !this.state.isCompleted && this.state.isPlaying;
                                        }}
                                        isPaused={() =>{
                                            return this.state.isPaused;
                                        }}
                                        onStop={() => {
                                            this._map.stopAnimation();
                                            this.setState({
                                                isPlaying: false,
                                                isPaused: false,
                                                _selectedLocationPt: null
                                            });
                                        }}
                                        onPause={() => {

                                            this._map.pauseAnimation();

                                            this.setState({
                                                isPaused: true,
                                                isPlaying: false,
                                                isCompleted: false,
                                                _selectedLocationPt: null
                                            });

                                        }}
                                    />
                                </div>

                                <div style={{marginTop: 10}}>

                                    <div className="clearfix">

                                        <div className="pull-right">

                                            <ButtonGroup>

                                                {/*<Button disabled={!this.state.historyData || this.state.historyData.length === 0} onClick={() => { }} size="sm"><i className="fa fa-map"/> Export KML</Button>*/}
                                                <Button disabled={!this.state.historyData || this.state.historyData.length === 0} onClick={() => {

                                                    this._areaCalculator.show({
                                                        historyData: this.state.historyData,
                                                        tractor: this.state.historyTractor,
                                                        start: this.state.locationRangeStart,
                                                        end: this.state.locationRangeEnd
                                                    });

                                                }} size="sm"><i className="fa fa-area-chart"/> Compute Area</Button>

                                                <Button disabled={!this.state.historyData || this.state.historyData.length === 0} onClick={() => {

                                                    const exporter = CsvExport.create({ filename: `${this.state.historyTractor.name}-LocationReport_${moment(this.state.locationRangeStart).format('DD/MM/YY')}-${moment(this.state.locationRangeEnd).format('DD/MM/YY')}.csv`, columns:
                                                            [
                                                                "Latitude",
                                                                "Longitude",
                                                                "Speed (km/H)",
                                                                "Motion",
                                                                "Time"
                                                            ]
                                                    });

                                                    const data = this.state.historyData.map(x => ({
                                                        "Latitude": x.lat,
                                                        "Longitude": x.lng,
                                                        "Speed (km/H)" : x.speed,
                                                        "Motion": (x.speed <= 0) ? "Stopped" : "Moving",
                                                        "Time": moment(x.time).format("LLL")
                                                    }));

                                                    exporter.downloadCsv(data);

                                                }} size="sm"><i className="fa fa-file"/> Export CSV</Button>

                                            </ButtonGroup>

                                        </div>

                                    </div>


                                    <DataList listRef={r => this._historyDataList = r}
                                              itemsPerPage={10}
                                              responsive
                                              data={state.historyData}
                                              getRowClass={item => {
                                                  return this.state._selectedLocationPt === item ? `${selectedLocationRow}` : undefined;
                                              }}
                                              defaultRowClass={`${locationItemRow}`}
                                              onRowClick={(item) => {

                                                  //    pause animation
                                                  if(!this.state.isCompleted && this.state.isPlaying)
                                                        this._playerControls.pause();

                                                  this.setStateSafe({
                                                      _selectedLocationPt: item
                                                  }, () => {

                                                      //
                                                      this._map.movePlaybackToTrack(state.historyData.indexOf(item));

                                                      //
                                                      this._map.panTo(item.lat,item.lng);
                                                  });

                                              }}
                                              noRowsMessage={"No history information found"}
                                              columns={[
                                                  {
                                                      key: "time",
                                                      label: "Time",
                                                      render: item => momentTimezone.parseZone(item.time).tz(momentTimezone.tz.guess()).format('l hh:mm a')
                                                  },
                                                  {
                                                      key: "speed",
                                                      label: "Speed (Km/H)"
                                                  },
                                                  {
                                                      key: "lat",
                                                      label: "Latitude"
                                                  },
                                                  {
                                                      key: "lng",
                                                      label: "Longitude"
                                                  }
                                              ]}/>

                                </div>

                            </div> : <div className="text-center">
                                <hr/>
                                <p>Select a tractor and a valid time range to show history here</p>
                            </div>}
                        </div>
                    }
                    else {
                        content = <div style={{padding: 10}} className="text-center">
                            <h5>Oops! No tractors available</h5>
                            <p>It seems there a no tractors with tracking devices installed</p>
                        </div>
                    }

                }

                break;
            case "geofence":
                content = <div>
                </div>;
                break;
            case "reports":
                content = <div>
                </div>;
                break;
        }

        return <div style={{padding: 10}}>
            {content}
        </div>
    }

    setActiveTab(tab){

        this.setState({
            tab: tab
        }, () => {

            //  apply filters
            this.applyFilters();

            //
            this.saveSession();
        });

        //
        this.onActivateTab(tab);


    }

    applyFilters(){

        history.push(joinQuery(history.location.pathname, createQuery({
            _from: this.state.locationRangeStart ? this.state.locationRangeStart.toJSON() : null,
            _to: this.state.locationRangeEnd ? this.state.locationRangeEnd.toJSON() : null,
            tab: this.state.tab,
            orientation: this.state.orientation,
            active_tractor: this.state.historyTractor ? this.state.historyTractor.id : undefined
        })));

    }

    parseQueryParams(query){

        const parseDate = (value) => {
            let v = moment(value);
            return !_.isNil(value) && v.isValid() ? v.toDate() : null;
        };

        const getActiveTab = () => {

            if(query.tab){

                if(!!NavTabs.find(x => x.name === query.tab)){
                    return query.tab;
                }
            }

            return this.session.getState('tab', NavTabs[0].name);
        };

        return {
            locationRangeStart: parseDate(query._from),
            locationRangeEnd: parseDate(query._to),
            tab: getActiveTab(),
            orientation: ["horizontal","vertical"].includes(query.orientation) ? query.orientation : this.session.getState('orientation','horizontal')
        };

    }

    render() {

        const actualHeight =  this.state.actualHeight;
        const actualWidth = this.state.actualWidth;
        const tractors = this.state.tractors || [];
        const trackers = this.state.trackers || [];
        const totalOnline = trackers.filter(x => x.status == GPSDeviceStatus.Online || x.status == GPSDeviceStatus.Running).length;
        const totalOffline = trackers.length - totalOnline;
        const isBottomCollapsed = this.state.isBottomCollapsed;

        const getSplitOptions = (split) => {

            if(split === "horizontal"){

                return {
                    split: "horizontal",
                    maxSize:isBottomCollapsed ? 50 : actualHeight * 0.6,
                    minSize:isBottomCollapsed ? actualHeight - 100 : actualHeight * 0.4,
                    allowResize: true,
                    style: {position: "inherit"}
                };

            }

            if(split === "vertical"){

                return {
                    split: "vertical",
                    maxSize:isBottomCollapsed ? 50 : actualWidth * 0.6,
                    minSize:isBottomCollapsed ? actualWidth - 100 : actualWidth * 0.4,
                    allowResize: true,
                    style: { position: "inherit" }
                };

            }

        };

        return (<LocationListener onChange={location => {

                    let query = QueryString.parse(location.search);
                    let _state = this.parseQueryParams(query);
                    this.setState({
                        ..._state
                    });


            }}>
                <DocumentTitle title="Tractor Maps View">
                    <div className="animated fadeIn" style={{ width: "100%" , height: "100%" }}>

                        <DeviceCommandsDialog ref={r => this._deviceCommandsDlg = r}/>

                        <SplitPane {...getSplitOptions(this.state.orientation)}>

                            <div style={Styles.full}>

                                <MapBase getTractors={this.getTractors.bind(this)}
                                         getLocations={this.getLocations.bind(this)}
                                         zoom={this.state.zoom}
                                         onZoomChanged={zoom => {

                                             this.setStateSafe({
                                                 zoom
                                             });

                                         }}
                                         onTractorSelected={(tractor,marker) => {

                                             // focus tractor
                                             this.focusTractor(tractor);

                                             // handle tractor selected
                                             this.handleTractorSelected(marker,tractor);

                                         }}
                                         googleMapOptions={{
                                             fullscreenControl: false,
                                             gestureHandling: 'greedy',
                                             disableDoubleClickZoom: false
                                         }}
                                         mapHeight={"100%"}
                                         onEndPlayAnimation={() => {

                                             //console.log('End animation playback');

                                             this.setState({
                                                 isPlaying: false,
                                                 isPaused: false,
                                                 isCompleted: true
                                             });

                                         }}
                                         onBeginPlayAnimation={() => {
                                             //console.log('Beginning animation playback');
                                         }}
                                         ref={r => this._map = r}>

                                    {this.state.historyData ? <HistoryPolyLine history={this.state.historyData} onClick={args => {

                                        const coord = args.latLng;
                                        const lat = coord.lat();
                                        const lng = coord.lng();
                                        const nearest = findNearest({ lat,lng },this.state.historyData);

                                        this._historyActionDlg.show([
                                            {
                                                label: "Move playback to selected",
                                                icon: "fa fa-map-marker",
                                                onClick: () => {

                                                    if(!this.state.isCompleted && this.state.isPlaying)
                                                        this._playerControls.pause();

                                                    this.setStateSafe({
                                                        _selectedLocationPt: nearest
                                                    }, () => {

                                                        //
                                                        this._map.movePlaybackToTrack(this.state.historyData.indexOf(nearest));

                                                        //
                                                        this._map.panTo(nearest.lat,nearest.lng);
                                                    });

                                                }
                                            }
                                        ]);


                                    }}/> : null}

                                </MapBase>

                            </div>

                            <div style={Styles.full}>

                                {this.state.orientation === "horizontal" && <div className="text-center">

                                    <CollapseToggleButton isToggled={isBottomCollapsed}
                                                          className="sidebar-toggle-btn"
                                                          style={{
                                                              width: 108 ,
                                                              fontSize: "x-small",
                                                              marginTop: isBottomCollapsed ? 6 : 0,
                                                          }}
                                                          onToggle={() => {
                                                              this.setStateSafe({
                                                                  isBottomCollapsed: !this.state.isBottomCollapsed
                                                              });
                                                          }}/>




                                </div>}


                                {<div style={{ padding : 20 , display: isBottomCollapsed ? "none" : "" }}>

                                    <div className="clearfix">

                                        <div className="pull-left">
                                            <h6>
                                                <Badge pill={true} color={"info"}>Tractors: <b>{tractors.length}</b> </Badge>
                                                <span style={{ marginLeft: 3 , marginRight: 3 , borderLeft: '#e8e8e8 solid 2px' }}/>
                                                <Badge pill={true} color="success">Online : <b>{totalOnline}</b></Badge>
                                                <Badge pill={true}>Offline: <b>{totalOffline}</b></Badge>
                                            </h6>
                                        </div>

                                        <div className="pull-right">
                                            <ButtonGroup style={{marginTop: -16}}>

                                                <Button size="sm"
                                                        style={{ width: 35 }}
                                                        title="Horizontal dock"
                                                        color={this.state.orientation === 'horizontal' ? "primary" : "secondary"}
                                                        onClick={() => this.setStateSafe({ orientation: "horizontal" }, () => {

                                                            //  apply filters
                                                            this.applyFilters();

                                                            this.saveSession();

                                                        })}><i className="fa fa-arrows-h"/>
                                                </Button>

                                                <Button size="sm"
                                                        style={{ width: 35 }}
                                                        title="Vertical dock"
                                                        color={this.state.orientation === 'vertical' ? "primary" : "secondary"}
                                                        onClick={() => this.setStateSafe({ orientation: "vertical"}, () => {

                                                            //  apply filters
                                                            this.applyFilters();

                                                            this.saveSession();

                                                        })}><i className="fa fa-arrows-v"/>
                                                </Button>

                                            </ButtonGroup>
                                        </div>

                                    </div>

                                    <div className="clearfix">

                                        <div className="pull-left">
                                            <Nav>
                                                {NavTabs.map((f,index) => {

                                                    return <NavItem key={index}>
                                                        <NavLink className={`tab-item ${this.state.tab === f.name ? "active-tab" : ""}`} style={{cursor: "pointer"}} onClick={() => {

                                                            //  set the current tab
                                                            this.setActiveTab(f.name);

                                                        }}>{HTML.renderIcon(f.icon)} {f.title}</NavLink>
                                                    </NavItem>;
                                                })}
                                            </Nav>
                                        </div>

                                        <div className="pull-right">

                                            {this.state.tab === "tractors" && <div>

                                                <input type="text"
                                                       className="form-control form-input"
                                                       placeholder="Search for tractors..."
                                                       value={this.state.searchKeyword || ""}
                                                       style={{
                                                           minWidth: 220
                                                       }}
                                                       onChange={evt => {

                                                           const value = evt.target.value;
                                                           let _tractors = null;
                                                           if(value !== "") {
                                                               _tractors = filterTractors(this.state.tractors, value);
                                                           }

                                                           this.setStateSafe({
                                                               searchKeyword: value,
                                                               searchTractors: _tractors
                                                           });

                                                       }} />

                                            </div>}

                                        </div>

                                    </div>

                                    {this.renderPage(this.state.tab)}

                                    {this.state.isBusy && <ProgressMD show={true}/>}

                                </div>}

                            </div>

                        </SplitPane>

                    </div>
                </DocumentTitle>
        </LocationListener>
        )
    }
}

// export default Maps;
export default MapFull;



// WEBPACK FOOTER //
// ./src/views/Maps/MapFull.js